<template>
  <div>
    <block v-if="loading"></block>
    <GeneralFilter
      entity="traspaso"
      :search="search"
      @emptyFilter="getTransfers"
      @filtered="filterHandler"
    >
      <DxDataGrid :data-source="transfer">
        <DxExport :enabled="true" />
        <DxScrolling row-rendering-mode="virtual" />
        <!--DxPaging :page-size="10" /-->
        <DxColumn
          :width="100"
          cell-template="show-template"
          caption=""
        ></DxColumn>
        <DxColumn data-field="ID_Transfer" caption="ID"></DxColumn>
        <DxColumn cell-template="formatTransferDate" data-field="TransferDate" caption="Fecha de solicitud"></DxColumn>
        <template #formatTransferDate="{ data }">
          <div>
            {{ moment(data.data.TransferDate).format("YYYY-MM-DD") }}
          </div>
        </template>
        <!--DxColumn
          data-field="DateTransfer"
          caption="Fecha de Aprobación"
        ></DxColumn-->
        <DxColumn data-field="OriginWarehouse" caption="Origen"></DxColumn>
        <DxColumn data-field="DestinyWarehouse" caption="Destino"></DxColumn>
        <!--DxColumn data-field="ReqName" caption="Usuario Solicita"></DxColumn-->
        <DxColumn data-field="UserFullName" caption="Usuario Aprobación"></DxColumn>
        <template #show-template="{ data }">
          <a
            href="#"
            class="mx-1"
            @click.prevent.stop="showTransferDetails(data)"
          >
            <v-icon color="primary">mdi-eye</v-icon>
          </a>
        </template>
      </DxDataGrid>
    </GeneralFilter>

    <div>
      <v-dialog v-model="showModal" max-width="1024">
        <v-card>
          <v-card-title>
            <v-row class="bg-dark text-h6 pa-2 rounded-lg">
              <v-col cols="12" md="3" align="center">
                <span class="font-weight-bold">ID Conversion: </span> {{ transferDetailData.ID_Transfer }}
              </v-col>
              <!--v-col cols="12" md="2" align="center">
                <span class="font-weight-bold">ID Solicitud:</span>
              </v-col-->
              <v-col cols="12" md="3" align="center">
                <span class="font-weight-bold">Almacen Origen:</span>
                <div>{{ transferDetailData.OriginWarehouse }}</div>
              </v-col>
              <v-col cols="12" md="3" align="center">
                <span class="font-weight-bold"> Destino:</span>
                <div>{{ transferDetailData.DestinyWarehouse }}</div>
              </v-col>
              <v-col cols="12" md="3" align="center">
                <span class="font-weight-bold">Usuario Solicita:</span>
                <div>{{ transferDetailData.UserFullName }}</div>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-col cols="12">
              <v-btn
                block
                dark
                large
                color="comment"
                class="rounded-lg"
                @click.prevent="showNotes = !showNotes"
              >
                <v-icon>mdi-comment</v-icon>
                <span class="text-h6">Comentarios</span>
              </v-btn>
            </v-col>
            <v-col cols="12" md="6">
              <span class="font-weight-bold">Fecha Solicitud: </span> {{ moment(transferDetailData.TransferDate).format("YYYY-MM-DD") }}
            </v-col>
              <DxDataGrid
                :data-source="transferDetailData.details"
                :show-row-line="ShowRowLines"
                :show-border="showBorder"
                width="100%"
              >
                <DxExport :enabled="true" />
                <DxPaging :page-size="10" />
                <DxColumn data-field="ID_Item" caption="ID Producto"></DxColumn>
                <DxColumn data-field="ItemName" caption="Nombre"></DxColumn>
                <DxColumn data-field="Amount" caption="Cantidad Solicitada"></DxColumn>
                <DxColumn cell-template="newQuantityOrigin" caption="Nueva existencia (Origen)"></DxColumn>
                <template #newQuantityOrigin="{ data }">
                  <div>
                    {{ data.data.ID_ItemParent ? data.data.ItemCurrentQuantity : "" }}
                  </div>
                </template>
                <DxColumn cell-template="newQuantityDestiny" caption="Nueva existencia (Destino)"></DxColumn>
                <template #newQuantityDestiny="{ data }">
                  <div>
                    {{ data.data.ID_ItemParent ? "" : data.data.ItemCurrentQuantity }}
                  </div>
                </template>
              </DxDataGrid>              
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog max-width="1024" v-model="showNotes">
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-btn small dark color="error" @click.prevent="showNotes = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <quill-editor
              :content="transferDetailData.Comments"
              :options="quillOptions"
              @change="onEditorChange($event)"
            ></quill-editor>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
  </div>
</template>

<script>
import GeneralFilter from "@/components/GeneralFilter.vue";
import { formatDate } from "../../../helpers/formatDate";
import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxScrolling,
  DxPaging,
} from "devextreme-vue/data-grid";
import Alerts from "@/components/Alerts.vue";
import Block from "@/components/Block.vue";

export default {
  name: "HistoryConversion",
  components: {
    GeneralFilter,
    DxDataGrid,
    DxColumn,
    DxExport,
    DxScrolling,
    DxPaging,
    Alerts,
    Block,
  },
  data() {
    return {
      transfer: [],
      showModal: false,
      ShowRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      showNotes: false,
      form: {},
      search: {
        filter: null,
      },
      loading: false,
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      transferDetailData: {}
    };
  },
  mounted() {
    this.getTransfers();
  },
  methods: {
    async getTransfers() {
      this.loading = true
      await this.$API.inventoryTransfer.getHistoryConversionProducts()
        .then(response => {
          this.transfer = response.data
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.showAlert(
            "warning",
            "Advertencia",
            error.message
          )
        })
    },

    filterHandler(response) {
      if (response.length > 0) {
        this.transfer = response.map((transfer) => ({
          ...transfer,
          TransferDate: formatDate(transfer.TransferDate),
        }));
      } else {
        this.transfer = response;
      }
    },

    filterTransferProduct({ filter, products }) {
      let filteredProducts = products.filter(
        (product) =>
          product.ID_Item.toString().includes(filter) ||
          product.ItemName.includes(filter) ||
          product.CantidadSolicitada.toString().includes(filter)
      );

      return new Promise((resolve) => {
        resolve(filteredProducts);
      });
    },

    onEditorChange(e) {
      this.form.comments = e.html;
    },

    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },

    closeAlert() {
      this.alert.show = false;
    },

    showTransferDetails(data) {
      this.transferDetailData = data.data
      this.showModal = !this.showModal
    }
  },
  props: {
    transferData: {
      type: Object,
    },
    isTransferApplication: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
